import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import { Multiselect } from 'multiselect-react-dropdown';
import Numeral from 'numeral';
import PageIndicator from '../components/PageIndicator';
import ImageUpload from '../components/ImageUpload';
import {enToFa} from '../utils/NumberUtility';
import {startCreateVehicleAd} from '../actions/vehicleAds';
import {startgetCitiesOfState, startgetSpecialCategories, startgetVehicleBrands, startgetValidVehicle} from '../actions/configs';

const VehicleRegister = (props) => {

    const stepTitles = {"1": "کاربری خودرو", "2": "اطلاعات فنی خودرو", "3": "قیمت و تصویر خودرو"};

    const multiStyle = {
        searchBox: {
            border: "none",
            "border-bottom": "1px solid #545454",
            "border-radius": "0px",
            "color": "black",
            "text-align": "start"
        },
        multiselectContainer: {
            color: "black",
            "text-align": "start"
        }
    }

    const [constructionYears, setConstructionYears] = useState([])

    useEffect(() => {
        if (props.sellType.length > 0) {
            const targetType = props.sellType.find( el => el.name === "نقدی").id
            set_cashId(targetType)
        }
    }, [props.sellType])
    useEffect(() => {
        if (constructionYears.length === 0){
            const tempYears = []
            for (let index = 1365; index < (new Date().getFullYear() - 620); index++) {
                tempYears.push(index)
            }
            setConstructionYears(tempYears)
        }
    }, [])

    // const [yearsUpdated, setYearsUpdated] = useState(false)
    const [cashId, set_cashId] = useState("1")
    const [brandValue, set_brandValue] = useState("-1")
    const [brandValueError, set_brandValueError] = useState(false)
    const [vehicleValue, set_VehicleValue] = useState("-1")
    const [vehicleValueError, set_vehicleValueError] = useState(false)
    const [gearboxValue, set_gearboxValue] = useState("-1")
    const [gearboxError, set_gearboxError] = useState(false)
    const [mileageValue, set_mileageValue] = useState("")
    const [mileageError, set_mileageError] = useState(false)
    const [description, set_description] = useState("")
    const [offeredPrice, set_offeredPrice] = useState("")
    const [offeredPriceError, set_offeredPriceError] = useState(false)
    const [breakTypeValue, set_breakTypeValue] = useState("-1")
    const [breakTypeError, set_breakTypeError] = useState(false)
    const [bodyColorValue, set_bodyColorValue] = useState("-1")
    const [bodyColorError, set_bodyColorError] = useState(false)
    const [interiorColorValue, set_interiorColorValue] = useState("-1")
    const [interiorColorError, set_interiorColorError] = useState(false)
    const [bodyStatusValue, set_bodyStatusValue] = useState("-1")
    const [bodyStatusError, set_bodyStatusError] = useState(false)
    const [moreFeaturesValue, set_moreFeaturesValue] = useState([])
    const [moreFeaturesError, set_moreFeaturesError] = useState(false)
    const [lengthValue, set_lengthValue] = useState("")
    const [lengthError, set_lengthError] = useState(false)
    const [axelCount, set_axelCountValue] = useState("")
    const [axelCountError, set_axelCountError] = useState(false)
    const [jackCapacity, set_jackCapacityValue] = useState("")
    const [jackCapacityError, set_jackCapacityError] = useState(false)
    const [loadCapacity, set_loadCapacityValue] = useState("")
    const [loadCapacityError, set_loadCapacityError] = useState(false)
    const [jackBrand, set_jackBrandValue] = useState("")
    const [jackBrandError, set_jackBrandError] = useState(false)
    const [belowMechanizms, set_belowMechanizmsValue] = useState("")
    const [belowMechanizmsError, set_belowMechanizmsError] = useState(false)
    const [passangerCapacity, set_passangerCapacityValue] = useState("")
    const [passangerCapacityError, set_passangerCapacityError] = useState(false)
    const [specialCategory, set_specialCategoryValue] = useState("-1")
    const [specialCategoryError, set_specialCategoryError] = useState(false)
    const [yearModel, set_yearModelValue] = useState("")
    const [yearModelError, set_yearModelError] = useState(false)
    const [state, set_stateValue] = useState("-1")
    const [stateError, set_stateError] = useState(false)
    const [city, set_cityValue] = useState("-1")
    const [cityError, set_cityError] = useState(false)
    const [insuranceStatus, set_insuranceStatusValue] = useState("-1")
    const [insuranceStatusError, set_insuranceStatusError] = useState(false)
    const [sellTypeValue, set_sellTypeValue] = useState("-1")
    const [sellTypeError, set_sellTypeError] = useState(false)
    const [relatedStore, setRelatedStore] = useState("-1")
    const [tireStatus, set_tireStatusValue] = useState("-1")
    const [tireStatusError, set_tireStatusError] = useState(false)
    

    const onBrandValueChanged = (e) => {
        if (e.target.value !== "-1" && e.target.value !== brandValue){
            set_brandValue(e.target.value)
            props.fetchVehicles(e.target.value, targetUsage)
            set_VehicleValue("-1")
            set_brandValueError(false)
        }
    }
    const onVehicleValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_VehicleValue(e.target.value)
            set_vehicleValueError(false)
        }
    }
    const onGearboxValueChanged = (e) => {
        if (e.target.value !== "-1"){
            set_gearboxValue(e.target.value)
            set_gearboxError(false)
        }
    }
    const onMileageValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)){
            set_mileageValue(e.target.value)
            set_mileageError(false)
        }
    }
    const onOfferedPriceValueChanged = (e) => {
        const pureValue = e.target.value.replace(/,/g, "")
        if (!!pureValue.match(/^[0-9]*$/)) {
            set_offeredPrice(pureValue)
            set_offeredPriceError(false)
        }
    }
    const onDescriptionChanged = (e) => {
        set_description(e.target.value)
    }
    const onBreakTypeValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_breakTypeValue(e.target.value)
            set_breakTypeError(false)
        }
    }
    const onBodyColorValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_bodyColorValue(e.target.value)
            set_bodyColorError(false)
        }
    }
    const onInteriorColorValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_interiorColorValue(e.target.value)
            set_interiorColorError(false)
        }
    }
    const onBodyStatusValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_bodyStatusValue(e.target.value)
            set_bodyStatusError(false)
        }
    }
    const onMoreFeaturesValueChanged = (e) => {
        const currentVal = e.target.value
        if (currentVal !== "-1"){
            if (moreFeaturesValue.includes(currentVal)) {
                set_moreFeaturesValue(moreFeaturesValue.filter((val) => val !== currentVal))
            } else {
                set_moreFeaturesValue([...moreFeaturesValue, currentVal])
            }
        }
        
    }
    const onMoreFeatureSelect = (selectedList, selectedItem) => {
        // console.log("add feature", selectedList, selectedItem)
        set_moreFeaturesValue(selectedList)
    }

    const onMoreFeatureRemove = (selectedList, selectedItem) => {
        // console.log("remove feature", selectedList, selectedItem)
        set_moreFeaturesValue(selectedList)
    }

    const onLengthValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            set_lengthValue(e.target.value)
            set_lengthError(false)
        }
    }
    const onAxelCountValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            set_axelCountValue(e.target.value)
            set_axelCountError(false)
        }
    }
    const onJackCapacityValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            set_jackCapacityValue(e.target.value)
        }
    }
    const onLoadCapacityValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            set_loadCapacityValue(e.target.value)
        }
    }
    const onJackBrandValueChanged = (e) => {
        set_jackBrandValue(e.target.value)
    }
    const onBelowMechanizmValueChanged = (e) => {
        set_belowMechanizmsValue(e.target.value)
        set_belowMechanizmsError(false)
    }
    const onPssengerCapacityValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            set_passangerCapacityValue(e.target.value)
        }
        set_passangerCapacityError(false)
    }
    const onSpecialCategoryValueChanged = (e) => {
        if (e.target.value !== "-1"){
            set_specialCategoryValue(e.target.value)
            set_specialCategoryError(false)
        }
    }
    const onYearModelValueChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)){
            set_yearModelValue(e.target.value)
            set_yearModelError(false)
        }
    }
    const onStateValueChanged = (e) => {
        if (e.target.value !== "-1" && e.target.value !== state) {
            set_stateValue(e.target.value)
            props.fetchCities(e.target.value)
            set_stateError(false)
            set_cityValue("-1")
        }
        
    }
    const onCityValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_cityValue(e.target.value)
            set_cityError(false)
        }
    }
    const onInsuranceStatusValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_insuranceStatusValue(e.target.value)
            set_insuranceStatusError(false)
        }
    }
    const onSellTypeValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_sellTypeValue(e.target.value)
            set_sellTypeError(false)
        }
    }
    const onRelatedStoreChanged = (e) => {
        if (e.target.value !== "-1") {
            setRelatedStore(e.target.value)
        }
    }
    const onTireStatusValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_tireStatusValue(e.target.value)
            set_tireStatusError(false)
        }
    }
    
    const vehicles = {
        common: [
            { field: 'brand', require: true },
            { field: 'vehicle', require: true },
            { field: 'yearModel', require: true },
            { field: 'state', require: true },
            { field: 'city', require: true },
            { field: 'insuranceStatus', require: true },
            { field: 'tireStatus', require: true },
        ],
        "2": [
            // { field: 'specialCategory', require: true },
            { field: 'gearbox', require: false },
            { field: 'mileage', require: true },
            // { field: 'breakType', require: false },
            { field: 'bodyColor', require: true },
            // { field: 'interiorColor', require: false },
            { field: 'bodyStatus', require: true },
            // { field: 'moreFeatures', require: false }
        ],
        "3": [
            { field: 'specialCategory', require: true },
            // { field: 'length', require: true },
            // { field: 'axelCount', require: true },
            // { field: 'breakType', require: false },
            // { field: 'jackCapacity', require: false },
            // { field: 'loadCapacity', require: false },
            // { field: 'jackBrand', require: false },
            // { field: 'moreFeatures', require: false },
        ],
        "4": [
            { field: 'specialCategory', require: true },
            { field: 'gearbox', require: false },
            { field: 'mileage', require: true },
            // { field: 'breakType', require: false },
            { field: 'bodyColor', require: true },
            // { field: 'interiorColor', require: false },
            { field: 'bodyStatus', require: true },
            { field: 'belowMechanizms', require: false },
            // { field: 'jackCapacity', require: false },
            // { field: 'loadCapacity', require: false },
            // { field: 'jackBrand', require: false },
            // { field: 'moreFeatures', require: false },
        ],
        "5": [
            { field: 'specialCategory', require: true },
            { field: 'gearbox', require: false },
            { field: 'mileage', require: true },
            // { field: 'breakType', require: false },
            { field: 'bodyColor', require: true },
            // { field: 'interiorColor', require: false },
            { field: 'bodyStatus', require: true },
            { field: 'belowMechanizms', require: false },
            // { field: 'jackCapacity', require: false },
            // { field: 'loadCapacity', require: false },
            // { field: 'jackBrand', require: false },
            // { field: 'moreFeatures', require: false },
        ],
        "6": [
            { field: 'specialCategory', require: true },
            { field: 'gearbox', require: false },
            { field: 'mileage', require: true },
            // { field: 'breakType', require: false },
            { field: 'bodyColor', require: true },
            // { field: 'interiorColor', require: false },
            { field: 'bodyStatus', require: true },
            // { field: 'jackCapacity', require: false },
            // { field: 'loadCapacity', require: false },
            // { field: 'jackBrand', require: false },
            // { field: 'moreFeatures', require: false },
        ],
        "7": [
            { field: 'specialCategory', require: true },
            { field: 'bodyColor', require: false },
            { field: 'bodyStatus', require: true },
            // { field: 'jackCapacity', require: false },
            // { field: 'loadCapacity', require: false },
            // { field: 'jackBrand', require: false },
            // { field: 'moreFeatures', require: false },
        ],
        "13": [
            { field: 'gearbox', require: false },
            { field: 'mileage', require: true },
            // { field: 'passangerCapacity', require: true },
            // { field: 'breakType', require: false },
            { field: 'bodyColor', require: true },
            // { field: 'interiorColor', require: false },
            { field: 'bodyStatus', require: true },
        ],
        "8": [
            { field: 'gearbox', require: false },
            { field: 'mileage', require: true },
            // { field: 'passangerCapacity', require: true },
            // { field: 'breakType', require: false },
            { field: 'bodyColor', require: true },
            // { field: 'interiorColor', require: false },
            { field: 'bodyStatus', require: true },
        ],
        "9": [
            { field: 'gearbox', require: false },
            { field: 'bodyColor', require: false },
            { field: 'bodyStatus', require: true },
        ],
        "10": [
            { field: 'specialCategory', require: true },
            { field: 'bodyColor', require: false },
            { field: 'bodyStatus', require: true }
        ],
        "11": [
            { field: 'specialCategory', require: true },
            { field: 'bodyColor', require: false },
            { field: 'bodyStatus', require: true }
        ],
        "12": [
            { field: 'specialCategory', require: true },
            { field: 'bodyColor', require: false },
            { field: 'bodyStatus', require: true }
        ],
        "14": [
            { field: 'mileage', require: true }
        ]
    }

    const moreFeaturesList = [
        'توربوشارژ',
        'ترمز موتوری',
        'اینتاردر / ریتاردر',
        'ABS',
        'قفل کن دیفرانسیل',
        'لاستیک زاپاس',
        'بخاری درجا',
        'کولر درجا',
        'کروز کنترل',
        'یخچال',
        'صندلی بادی'
    ]

    const configTranslateAndGetType = {
        brand: { type: 'select', translate: 'برند' },
        vehicle: { type: 'select', translate: 'تیپ' },
        yearModel: { type: 'select', translate: 'سال ساخت' },
        state: { type: 'select', translate: 'استان' },
        specialCategory: { type: 'select', translate: 'نوع کاربری' },
        axelCount: { type: 'number', translate: 'تعداد محور' },
        gearbox: { type: 'select', translate: 'گیربکس' },
        mileage: { type: 'number', translate: 'کارکرد(کیلومتر)' },
        passangerCapacity: { type: 'number', translate: 'تعداد صندلی' },
        length: { type: 'number', translate: 'طول تریلی(متر)' },
        breakType: { type: 'select', translate: 'وضعیت ترمز' },
        interiorColor: { type: 'select', translate: 'رنگ داخل' },
        bodyStatus: { type: 'select', translate: 'وضعیت بدنه' },
        insuranceStatus: { type: 'select', translate: 'وضعیت بیمه' },
        city: { type: 'select', translate: 'شهر' },
        bodyColor: { type: 'select', translate: 'رنگ بدنه' },
        tireStatus: { type: 'select', translate: 'وضعیت لاستیک' },
        jackCapacity: { type: 'number', translate: 'ظرفیت جک نگه دارنده(تن)' },
        loadCapacity: { type: 'number', translate: 'ظرفیت بارگیری' },
        jackBrand: { type: 'text', translate: 'برند جک' },
        moreFeatures: { type: 'multi-select', translate: 'سایر امکانات' },
        belowMechanizms: { type: 'text', translate: 'نوع اتاق' },

    }

    const [isSending, setSending] = useState(false);
    const [step, setStep] = useState(1);
    const [targetUsage, setTargetUsage] = useState("-1");
    const [targetUsageError, setTargetUsageError] = useState(false);

    const [imageOne, setImageOne] = useState();
    const [imageTwo, setImageTwo] = useState();
    const [imageThree, setImageThree] = useState();
    const [imageFour, setImageFour] = useState();

    const firstRef = React.createRef();
    const secondRef = React.createRef();
    const thirdRef = React.createRef();
    const fourthRef = React.createRef();

    const onUsageChanged = (e) => {
        console.log(e.target.value);
        if (e.target.value !== "-1" && e.target.value !== targetUsage){
            props.fetchBrands(e.target.value)
            props.fetchSpecialCategory(e.target.value)
            setTargetUsage(e.target.value)
            setTargetUsageError(false)
            set_brandValue("-1")
            set_brandValueError(false)
            set_VehicleValue("-1")
            set_vehicleValueError(false)
            set_gearboxValue("-1")
            set_gearboxError(false)
            set_mileageValue("")
            set_mileageError(false)
            set_breakTypeValue("-1")
            set_breakTypeError(false)
            set_bodyColorValue("-1")
            set_bodyColorError(false)
            set_interiorColorValue("-1")
            set_interiorColorError(false)
            set_bodyStatusValue("-1")
            set_bodyStatusError(false)
            set_moreFeaturesValue([])
            set_moreFeaturesError(false)
            set_lengthValue("")
            set_lengthError(false)
            set_axelCountValue("")
            set_axelCountError(false)
            set_jackCapacityValue("")
            set_jackCapacityError(false)
            set_loadCapacityValue("")
            set_loadCapacityError(false)
            set_jackBrandValue("")
            set_jackBrandError(false)
            set_belowMechanizmsValue("")
            set_belowMechanizmsError(false)
            set_passangerCapacityValue("")
            set_passangerCapacityError(false)
            set_specialCategoryValue("-1")
            set_specialCategoryError(false)
            set_yearModelValue("")
            set_yearModelError(false)
            set_stateValue("-1")
            set_stateError(false)
            set_cityValue("-1")
            set_cityError(false)
            set_insuranceStatusValue("-1")
            set_insuranceStatusError(false)
            set_tireStatusValue("-1")
            set_tireStatusError(false)
        }
    }

    const onPrevPressed = () => {
        switch (step) {
            case 2:
                setStep(1);
                break;
            case 3:
                setStep(2);
                break;
        }
    }

    const onNextPressed = () => {
        console.log("sss", targetUsage);
        
        switch (step) {
            case 1:
                if (targetUsage === "-1"){
                    setTargetUsageError(true)
                }
                else {
                    setTargetUsageError(false)
                    setStep(2);
                }
                break;
            case 2:
                if (formInfoValidation()){
                    setStep(3);
                }
                break;
            case 3:
                if (validateStepThree()){
                    onFinalizeForSend()
                }
                break;
        }
    }

    const onFinalizeForSend = () => {
        let adBody = new FormData()
        if (vehicleValue !== "-1") {
            adBody.append("vehicle", vehicleValue)
        }
        if (gearboxValue !== "-1") {
            adBody.append("gearbox", gearboxValue)
        }
        if (mileageValue !== "") {
            adBody.append("mileage", mileageValue)
        }
        if (relatedStore !== "-1") {
            const store = relatedStore.split('-')
            if (store[0] === "agency"){
                adBody.append("relatedAgency", store[1])
            }
            else {
                adBody.append("relatedGallery", store[1])
            }
        }
        if (description !== "") {
            adBody.append("description", description)
        }
        if (offeredPrice !== "") {
            adBody.append("price", offeredPrice)
        }
        if (breakTypeValue !== "-1") {
            adBody.append("breakType", breakTypeValue)
        }
        if (bodyColorValue !== "-1") {
            adBody.append("bodyColor", bodyColorValue)
        }
        if (interiorColorValue !== "-1") {
            adBody.append("interiorColor", interiorColorValue)
        }
        if (bodyStatusValue !== "-1") {
            adBody.append("bodyStatus", bodyStatusValue)
        }
        if (moreFeaturesValue.length !== 0) {
            adBody.append("moreFeatures", moreFeaturesValue.join("&"))
        }
        if (lengthValue !== "") {
            adBody.append("length", lengthValue)
        }
        if (axelCount !== "") {
            adBody.append("axelCount", axelCount)
        }
        if (description !== "") {
            adBody.append("description", description)
        }
        if (jackCapacity !== "") {
            adBody.append("jackCapacity", jackCapacity)
        }
        if (loadCapacity !== "") {
            adBody.append("loadCapacity", loadCapacity)
        }
        if (jackBrand !== "") {
            adBody.append("jackBrand", jackBrand)
        }
        if (belowMechanizms !== "") {
            adBody.append("belowMechanizms", belowMechanizms)
        }
        if (passangerCapacity !== "") {
            adBody.append("passangerCapacity", passangerCapacity)
        }
        if (specialCategory !== "-1") {
            adBody.append("specialCategory", specialCategory)
        }
        if (yearModel !== "-1") {
            adBody.append("yearModel", yearModel)
        }
        if (city !== "-1") {
            adBody.append("city", city)
        }
        if (insuranceStatus !== "-1") {
            adBody.append("insuranceStatus", insuranceStatus)
        }
        if (sellTypeValue !== "") {
            adBody.append("type", sellTypeValue)
        }
        if (tireStatus !== "") {
            adBody.append("tireStatus", tireStatus)
        }
        if (!!imageOne) {
            adBody.append("image_1", imageOne)
        }
        if (!!imageTwo) {
            adBody.append("image_2", imageTwo)
        }
        if (!!imageThree) {
            adBody.append("image_3", imageThree)
        }
        if (!!imageFour) {
            adBody.append("image_4", imageFour)
        }
        setSending(true)
        props.createAd(adBody)
        .then(({success, error}) => {
            if (success){
                props.history.push('/dashboard')
            } else {
                setSending(false)
            }
        })
    }

    const formInfoValidation = () => {
        if (validateCommon()){
            switch(targetUsage){
                case "2":
                    console.log("val26", validate26());
                    return validate26()
                case "3":
                    return validate3()
                case "4":
                    return validate45()
                case "5":
                    return validate45()
                case "6":
                    return validate26()
                case "7":
                    return validate7101112()
                case "8":
                    return validate138()
                case "9":
                    return validate9()
                case "10":
                    return validate7101112()
                case "11":
                    return validate7101112()
                case "12":
                    return validate7101112()
                case "13":
                    return validate138()
                case "14":
                    return validate14()
            }
        }
        else {
            return false
        }
    }

    const yearValidity = (value) => {
        const upper = new Date().getFullYear()
        const lower = 1365
        return value <= upper && value >= lower
    }

    const validateCommon = () => {
        let hasError = false;
        if (brandValue === "-1"){
            set_brandValueError(true)
            hasError = true
        } else{
            set_brandValueError(false)
        }
        if (vehicleValue === "-1") {
            set_vehicleValueError(true)
            hasError = true
        } else {
            set_vehicleValueError(false)
        }
        if (yearModel === "" || !yearValidity(yearModel)) {
            set_yearModelError(true)
            hasError = true
        } else {
            set_yearModelError(false)
        }
        if (state === "-1") {
            set_stateError(true)
            hasError = true
        } else {
            set_stateError(false)
        }
        if (city === "-1") {
            set_cityError(true)
            hasError = true
        } else {
            set_cityError(false)
        }
        if (insuranceStatus === "-1") {
            set_insuranceStatusError(true)
            hasError = true
        } else {
            set_insuranceStatusError(false)
        }
        if (tireStatus === "-1") {
            set_tireStatusError(true)
            hasError = true
        } else {
            set_tireStatusError(false)
        }
        return !hasError
    }

    const validateStepThree = () => {
        let hasError = false;
        if (sellTypeValue === "-1"){
            set_sellTypeError(true)
            hasError = true
        } else {
            set_sellTypeError(false)
        }
        if (offeredPrice === "" && sellTypeValue == cashId) {
            set_offeredPriceError(true)
            hasError = true
        } else {
            set_offeredPriceError(false)
        }
        return !hasError
    }

    const validate26 = () => {
        let hasError = false;
        // if (specialCategory === "-1") {
        //     set_specialCategoryError(true)
        //     hasError = true
        // } else {
        //     set_specialCategoryError(false)
        // }
        // if (gearboxValue === "-1") {
        //     set_gearboxError(true)
        //     hasError = true
        // } else {
        //     set_gearboxError(false)
        // }
        if (mileageValue === "") {
            set_mileageError(true)
            hasError = true
        } else {
            set_mileageError(false)
        }
        if (bodyColorValue === "-1") {
            set_bodyColorError(true)
            hasError = true
        } else {
            set_bodyColorError(false)
        }
        if (bodyStatusValue === "-1") {
            set_bodyStatusError(true)
            hasError = true
        } else {
            set_bodyStatusError(false)
        }
        return !hasError
    }

    const validate3 = () => {
        let hasError = false;
        if (specialCategory === "-1") {
            set_specialCategoryError(true)
            hasError = true
        } else {
            set_specialCategoryError(false)
        }
        // if (lengthValue === "") {
        //     set_lengthError(true)
        //     hasError = true
        // } else {
        //     set_lengthError(false)
        // }
        // if (axelCount === "") {
        //     set_axelCountError(true)
        //     hasError = true
        // } else {
        //     set_axelCountError(false)
        // }
        return !hasError
    }

    const validate45 = () => {
        let hasError = false;
        if (specialCategory === "-1") {
            set_specialCategoryError(true)
            hasError = true
        } else {
            set_specialCategoryError(false)
        }
        if (mileageValue === "") {
            set_mileageError(true)
            hasError = true
        } else {
            set_mileageError(false)
        }
        if (bodyColorValue === "-1") {
            set_bodyColorError(true)
            hasError = true
        } else {
            set_bodyColorError(false)
        }
        if (bodyStatusValue === "-1") {
            set_bodyStatusError(true)
            hasError = true
        } else {
            set_bodyStatusError(false)
        }
        return !hasError
    }

    const validate7101112 = () => {
        let hasError = false;
        if (specialCategory === "-1") {
            set_specialCategoryError(true)
            hasError = true
        } else {
            set_specialCategoryError(false)
        }
        if (bodyStatusValue === "-1") {
            set_bodyStatusError(true)
            hasError = true
        } else {
            set_bodyStatusError(false)
        }
        return !hasError
    }

    const validate138 = () => {
        let hasError = false;
        // if (gearboxValue === "-1") {
        //     set_gearboxError(true)
        //     hasError = true
        // } else {
        //     set_gearboxError(false)
        // }
        if (mileageValue === "") {
            set_mileageError(true)
            hasError = true
        } else {
            set_mileageError(false)
        }
        // if (passangerCapacity === "") {
        //     set_passangerCapacityError(true)
        //     hasError = true
        // } else {
        //     set_passangerCapacityError(false)
        // }
        if (bodyColorValue === "-1") {
            set_bodyColorError(true)
            hasError = true
        } else {
            set_bodyColorError(false)
        }
        if (bodyStatusValue === "-1") {
            set_bodyStatusError(true)
            hasError = true
        } else {
            set_bodyStatusError(false)
        }
        return !hasError
    }

    const validate9 = () => {
        let hasError = false;
        // if (gearboxValue === "-1") {
        //     set_gearboxError(true)
        //     hasError = true
        // } else {
        //     set_gearboxError(false)
        // }
        if (bodyStatusValue === "-1") {
            set_bodyStatusError(true)
            hasError = true
        } else {
            set_bodyStatusError(false)
        }
        return !hasError
    }

    const validate14 = () => {
        let hasError = false;
        if (mileageValue === "") {
            set_mileageError(true)
            hasError = true
        } else {
            set_mileageError(false)
        }
        return !hasError
    }
    

    const stepOne = () => {
        return (
            <>
                <select className={targetUsageError ? "register__dropdown--error" : "register__dropdown"} onChange={onUsageChanged} value={targetUsage}>
                    <option value="-1">کاربری</option>
                    {props.usages.map((usage) => {
                        return (<option key={usage.id} value={usage.id}>{usage.name}</option>)
                    })}
                </select>
            </>
        )
    }

    const stepTwo = () => {
        switch (targetUsage){
            case '2':
                return usage2();
            case '3':
                return usage3();
            case '4':
                return usage4();
            case '5':
                return usage4();
            case '6':
                return usage4();
            case '7':
                return usage7();
            case '8':
                return usage8();
            case '9':
                return usage9();
            case '10':
                return usage10();
            case '11':
                return usage10();
            case '12':
                return usage10();
            case '13':
                return usage8();
            case '14':
                return usage14();
        }
    }

    const usage2 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <select className={specialCategoryError ? "register__dropdown--error" : "register__dropdown"} value={specialCategory} onChange={onSpecialCategoryValueChanged}>
                    <option value="-1">نوع کاربری</option>
                    {
                        props.specialCategories.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={gearboxError ? "register__dropdown--error" : "register__dropdown"} value={gearboxValue} onChange={onGearboxValueChanged}>
                    <option value="-1">گیربکس</option>
                    {
                        props.gearbox.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={mileageError ? "register__dropdown--error" : "register__dropdown"} value={mileageValue} onChange={onMileageValueChanged} type="text" placeholder="کارکرد (کیلومتر)"></input>
                {/* <select className={breakTypeError ? "register__dropdown--error" : "register__dropdown"} value={breakTypeValue} onChange={onBreakTypeValueChanged}>
                    <option value="-1">سیستم ترمز</option>
                    {
                        props.breakType.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={bodyColorError ? "register__dropdown--error" : "register__dropdown"} value={bodyColorValue} onChange={onBodyColorValueChanged}>
                    <option value="-1">رنگ بدنه</option>
                    {
                        props.bodyColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <select className={interiorColorError ? "register__dropdown--error" : "register__dropdown"} value={interiorColorValue} onChange={onInteriorColorValueChanged}>
                    <option value="-1">رنگ داخل</option>
                    {
                        props.interiorColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={bodyStatusError ? "register__dropdown--error" : "register__dropdown"} value={bodyStatusValue} onChange={onBodyStatusValueChanged}>
                    <option value="-1">وضعیت بدنه</option>
                    {
                        props.bodyStatus.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <select className={moreFeaturesError ? "register__dropdown--error" : "register__dropdown"} multiple value={moreFeaturesValue} onChange={onMoreFeaturesValueChanged}>
                    <option value="" disabled selected >سایر امکانات</option>
                    {
                        moreFeaturesList.map((el, idx) => (
                            <option key={el} value={el}>{el}</option>
                        ))
                    }
                </select> */}
                {/* <Multiselect
                    options={moreFeaturesList}
                    selectedValues={moreFeaturesValue}
                    onSelect={onMoreFeatureSelect} // Function will trigger on select event
                    onRemove={onMoreFeatureRemove} // Function will trigger on remove event
                    isObject={false}
                    closeIcon = "cancel"
                    avoidHighlightFirstOption={true}
                    placeholder="سایر امکانات"
                    closeOnSelect={false}
                    style={multiStyle}
                /> */}
            </>
        )
    }

    const usage3 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={specialCategoryError ? "register__dropdown--error" : "register__dropdown"} value={specialCategory} onChange={onSpecialCategoryValueChanged}>
                    <option value="-1">نوع کاربری</option>
                    {
                        props.specialCategories.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <input className={lengthError ? "register__dropdown--error" : "register__dropdown"} value={lengthValue} onChange={onLengthValueChanged} type="text" placeholder="طول تریلی(متر)"></input>
                <input className={axelCountError ? "register__dropdown--error" : "register__dropdown"} value={axelCount} onChange={onAxelCountValueChanged} type="text" placeholder="تعداد محور"></input>
                <select className={breakTypeError ? "register__dropdown--error" : "register__dropdown"} value={breakTypeValue} onChange={onBreakTypeValueChanged}>
                    <option value="-1">سیستم ترمز</option>
                    {
                        props.breakType.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={jackCapacityError ? "register__dropdown--error" : "register__dropdown"} value={jackCapacity} onChange={onJackCapacityValueChanged} type="text" placeholder="ظرفیت جک نگهدارنده"></input>
                <input className={loadCapacityError ? "register__dropdown--error" : "register__dropdown"} value={loadCapacity} onChange={onLoadCapacityValueChanged} type="text" placeholder="ظرفیت بارگیری"></input>
                <input className={jackBrandError ? "register__dropdown--error" : "register__dropdown"} value={jackBrand} onChange={onJackBrandValueChanged} type="text" placeholder="برند جک"></input> */}
                {/* <select className={moreFeaturesError ? "register__dropdown--error" : "register__dropdown"} multiple value={moreFeaturesValue} onChange={onMoreFeaturesValueChanged}>
                    <option value="-1">سایر امکانات</option>
                    {
                        moreFeaturesList.map((el, idx) => (
                            <option key={idx} value={el}>{el}</option>
                        ))
                    }
                </select> */}
                {/* <Multiselect
                    options={moreFeaturesList}
                    selectedValues={moreFeaturesValue}
                    onSelect={onMoreFeatureSelect} // Function will trigger on select event
                    onRemove={onMoreFeatureRemove} // Function will trigger on remove event
                    isObject={false}
                    closeIcon = "cancel"
                    avoidHighlightFirstOption={true}
                    placeholder="سایر امکانات"
                    closeOnSelect={false}
                    style={multiStyle}
                /> */}
            </>
        )
    }

    const usage4 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={specialCategoryError ? "register__dropdown--error" : "register__dropdown"} value={specialCategory} onChange={onSpecialCategoryValueChanged}>
                    <option value="-1">نوع کاربری</option>
                    {
                        props.specialCategories.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={gearboxError ? "register__dropdown--error" : "register__dropdown"} value={gearboxValue} onChange={onGearboxValueChanged}>
                    <option value="-1">گیربکس</option>
                    {
                        props.gearbox.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={mileageError ? "register__dropdown--error" : "register__dropdown"} value={mileageValue} onChange={onMileageValueChanged} type="text" placeholder="کارکرد (کیلومتر)"></input>
                {/* <select className={breakTypeError ? "register__dropdown--error" : "register__dropdown"} value={breakTypeValue} onChange={onBreakTypeValueChanged}>
                    <option value="-1">سیستم ترمز</option>
                    {
                        props.breakType.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={bodyColorError ? "register__dropdown--error" : "register__dropdown"} value={bodyColorValue} onChange={onBodyColorValueChanged}>
                    <option value="-1">رنگ بدنه</option>
                    {
                        props.bodyColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <select className={interiorColorError ? "register__dropdown--error" : "register__dropdown"} value={interiorColorValue} onChange={onInteriorColorValueChanged}>
                    <option value="-1">رنگ داخل</option>
                    {
                        props.interiorColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={bodyStatusError ? "register__dropdown--error" : "register__dropdown"} value={bodyStatusValue} onChange={onBodyStatusValueChanged}>
                    <option value="-1">وضعیت بدنه</option>
                    {
                        props.bodyStatus.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={belowMechanizmsError ? "register__dropdown--error" : "register__dropdown"} value={belowMechanizms} onChange={onBelowMechanizmValueChanged} type="text" placeholder="نوع اتاق"></input>
                {/* <input className={jackCapacityError ? "register__dropdown--error" : "register__dropdown"} value={jackCapacity} onChange={onJackCapacityValueChanged} type="text" placeholder="ظرفیت جک نگهدارنده"></input>
                <input className={loadCapacityError ? "register__dropdown--error" : "register__dropdown"} value={loadCapacity} onChange={onLoadCapacityValueChanged} type="text" placeholder="ظرفیت بارگیری"></input>
                <input className={jackBrandError ? "register__dropdown--error" : "register__dropdown"} value={jackBrand} onChange={onJackBrandValueChanged} type="text" placeholder="برند جک"></input> */}
                {/* <select className={moreFeaturesError ? "register__dropdown--error" : "register__dropdown"} multiple value={moreFeaturesValue} onChange={onMoreFeaturesValueChanged}>
                    <option value="-1">سایر امکانات</option>
                    {
                        moreFeaturesList.map((el, idx) => (
                            <option key={idx} value={el}>{el}</option>
                        ))
                    }
                </select> */}
                {/* <Multiselect
                    options={moreFeaturesList}
                    selectedValues={moreFeaturesValue}
                    onSelect={onMoreFeatureSelect} // Function will trigger on select event
                    onRemove={onMoreFeatureRemove} // Function will trigger on remove event
                    isObject={false}
                    closeIcon = "cancel"
                    avoidHighlightFirstOption={true}
                    placeholder="سایر امکانات"
                    closeOnSelect={false}
                    style={multiStyle}
                /> */}
            </>
        )
    }

    const usage7 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={specialCategoryError ? "register__dropdown--error" : "register__dropdown"} value={specialCategory} onChange={onSpecialCategoryValueChanged}>
                    <option value="-1">نوع کاربری</option>
                    {
                        props.specialCategories.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={bodyColorError ? "register__dropdown--error" : "register__dropdown"} value={bodyColorValue} onChange={onBodyColorValueChanged}>
                    <option value="-1">رنگ بدنه</option>
                    {
                        props.bodyColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={bodyStatusError ? "register__dropdown--error" : "register__dropdown"} value={bodyStatusValue} onChange={onBodyStatusValueChanged}>
                    <option value="-1">وضعیت بدنه</option>
                    {
                        props.bodyStatus.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <input className={jackCapacityError ? "register__dropdown--error" : "register__dropdown"} value={jackCapacity} onChange={onJackCapacityValueChanged} type="text" placeholder="ظرفیت جک نگهدارنده"></input>
                <input className={loadCapacityError ? "register__dropdown--error" : "register__dropdown"} value={loadCapacity} onChange={onLoadCapacityValueChanged} type="text" placeholder="ظرفیت بارگیری"></input>
                <input className={jackBrandError ? "register__dropdown--error" : "register__dropdown"} value={jackBrand} onChange={onJackBrandValueChanged} type="text" placeholder="برند جک"></input> */}
                {/* <select className={moreFeaturesError ? "register__dropdown--error" : "register__dropdown"} multiple value={moreFeaturesValue} onChange={onMoreFeaturesValueChanged}>
                    <option value="-1">سایر امکانات</option>
                    {
                        moreFeaturesList.map((el, idx) => (
                            <option key={idx} value={el}>{el}</option>
                        ))
                    }
                </select> */}
                {/* <Multiselect
                    options={moreFeaturesList}
                    selectedValues={moreFeaturesValue}
                    onSelect={onMoreFeatureSelect} // Function will trigger on select event
                    onRemove={onMoreFeatureRemove} // Function will trigger on remove event
                    isObject={false}
                    closeIcon = "cancel"
                    avoidHighlightFirstOption={true}
                    placeholder="سایر امکانات"
                    closeOnSelect={false}
                    style={multiStyle}
                /> */}
            </>
        )
    }

    const usage8 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={gearboxError ? "register__dropdown--error" : "register__dropdown"} value={gearboxValue} onChange={onGearboxValueChanged}>
                    <option value="-1">گیربکس</option>
                    {
                        props.gearbox.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={mileageError ? "register__dropdown--error" : "register__dropdown"} value={mileageValue} onChange={onMileageValueChanged} type="text" placeholder="کارکرد (کیلومتر)"></input>
                {/* <input className={passangerCapacityError ? "register__dropdown--error" : "register__dropdown"} value={passangerCapacity} onChange={onPssengerCapacityValueChanged} type="text" placeholder="کارکرد (کیلومتر)"></input>
                <select className={breakTypeError ? "register__dropdown--error" : "register__dropdown"} value={breakTypeValue} onChange={onBreakTypeValueChanged}>
                    <option value="-1">سیستم ترمز</option>
                    {
                        props.breakType.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={bodyColorError ? "register__dropdown--error" : "register__dropdown"} value={bodyColorValue} onChange={onBodyColorValueChanged}>
                    <option value="-1">رنگ بدنه</option>
                    {
                        props.bodyColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                {/* <select className={interiorColorError ? "register__dropdown--error" : "register__dropdown"} value={interiorColorValue} onChange={onInteriorColorValueChanged}>
                    <option value="-1">رنگ داخل</option>
                    {
                        props.interiorColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select> */}
                <select className={bodyStatusError ? "register__dropdown--error" : "register__dropdown"} value={bodyStatusValue} onChange={onBodyStatusValueChanged}>
                    <option value="-1">وضعیت بدنه</option>
                    {
                        props.bodyStatus.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
            </>
        )
    }

    const usage9 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={gearboxError ? "register__dropdown--error" : "register__dropdown"} value={gearboxValue} onChange={onGearboxValueChanged}>
                    <option value="-1">گیربکس</option>
                    {
                        props.gearbox.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={bodyColorError ? "register__dropdown--error" : "register__dropdown"} value={bodyColorValue} onChange={onBodyColorValueChanged}>
                    <option value="-1">رنگ بدنه</option>
                    {
                        props.bodyColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={bodyStatusError ? "register__dropdown--error" : "register__dropdown"} value={bodyStatusValue} onChange={onBodyStatusValueChanged}>
                    <option value="-1">وضعیت بدنه</option>
                    {
                        props.bodyStatus.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
            </>
        )
    }

    const usage10 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={specialCategoryError ? "register__dropdown--error" : "register__dropdown"} value={specialCategory} onChange={onSpecialCategoryValueChanged}>
                    <option value="-1">نوع کاربری</option>
                    {
                        props.specialCategories.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={bodyColorError ? "register__dropdown--error" : "register__dropdown"} value={bodyColorValue} onChange={onBodyColorValueChanged}>
                    <option value="-1">رنگ بدنه</option>
                    {
                        props.bodyColor.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={bodyStatusError ? "register__dropdown--error" : "register__dropdown"} value={bodyStatusValue} onChange={onBodyStatusValueChanged}>
                    <option value="-1">وضعیت بدنه</option>
                    {
                        props.bodyStatus.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
            </>
        )
    }

    const usage14 = () => {
        return (
            <>
                <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                    <option value="-1">برند</option>
                    {
                        props.usageBrands.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                    <option value="-1">تیپ</option>
                    {
                        props.validVehicles.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={yearModelError ? "register__dropdown--error" : "register__dropdown"} value={yearModel} onChange={onYearModelValueChanged} type="text" placeholder="سال ساخت"></input>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={insuranceStatusError ? "register__dropdown--error" : "register__dropdown"} value={insuranceStatus} onChange={onInsuranceStatusValueChanged}>
                    <option value="-1">وضعیت بیمه</option>
                    {
                        props.insurance.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={tireStatusError ? "register__dropdown--error" : "register__dropdown"} value={tireStatus} onChange={onTireStatusValueChanged}>
                    <option value="-1">وضعیت لاستیک</option>
                    {
                        props.tire.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={mileageError ? "register__dropdown--error" : "register__dropdown"} value={mileageValue} onChange={onMileageValueChanged} type="text" placeholder="کارکرد (کیلومتر)"></input>
            </>
        )
    }

    const stepThree = () => {
        return (
            <>
                <select className={sellTypeError ? "register__dropdown--error" : "register__dropdown"} value={sellTypeValue} onChange={onSellTypeValueChanged}>
                    <option value="-1">شرایط پرداخت</option>
                    {
                        props.sellType.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                            ))
                        }
                </select>
                {!!sellTypeValue && sellTypeValue == cashId && <input disabled={props.reducedSellType[sellTypeValue] && props.reducedSellType[sellTypeValue] === "توافقی"} className={offeredPriceError ? "register__dropdown--error" : "register__dropdown"} value={offeredPrice === "" ? "" :Numeral(offeredPrice).format('0,0')} onChange={onOfferedPriceValueChanged} type="text" placeholder="قیمت پیشنهادی"></input>}
                {(props.userAgencies.length > 0 || props.userGalleries.length > 0) ? (
                    <select className="register__dropdown" value={relatedStore} onChange={onRelatedStoreChanged}>
                    <option value="-1">نمایندگی/نمایشگاه مرتبط</option>
                    {
                        props.userAgencies.map((el, idx) => (
                            <option key={idx} value={`agency-${el.id}`}>{el.galleryTitle}</option>
                        ))
                    }{
                        props.userGalleries.map((el, idx) => (
                            <option key={idx} value={`gallery-${el.id}`}>{el.galleryTitle}</option>
                        ))
                    }
                </select>
                ) : undefined}
                <textarea className="about__text-area p-3 mb-3 mt-4" type="text" value={description} onChange={onDescriptionChanged} rows="5" placeholder="توضیحات فروشنده" />
                <div className="optimized__d-flex-class flex-wrap align-items-stretch justify-content-between mt-4">
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر اول" image={imageOne} inputRefrence={firstRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-one"/>
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر دوم" image={imageTwo} inputRefrence={secondRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-two"/>
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر سوم" image={imageThree} inputRefrence={thirdRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-three"/>
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر چهارم" image={imageFour} inputRefrence={fourthRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-four"/>
                </div>
            </>
        )
    }

    const imageChooser = (e) => {
        console.log("image chooser", e.target.value, e.target.files);
        
        if (e.target.files.length > 0 && !!e.target.value.match(/.(jpg|jpeg|png)$/))
        switch (e.target.id) {
            case "file-upload-img-one":
                setImageOne(e.target.files[0])
                break;
            case "file-upload-img-two":
                setImageTwo(e.target.files[0])
                break;
            case "file-upload-img-three":
                setImageThree(e.target.files[0])
                break;
            case "file-upload-img-four":
                setImageFour(e.target.files[0])
                break;
        }
    }

    const removeImage = (e) => {
        // console.log("remove item id", e.target.id, firstRef.current.value)
        switch (e.target.id) {
            case "remove_file-upload-img-one":
                setImageOne(undefined)
                firstRef.current.value = null;
                break;
            case "remove_file-upload-img-two":
                setImageTwo(undefined)
                secondRef.current.value = null;
                break;
            case "remove_file-upload-img-three":
                setImageThree(undefined)
                thirdRef.current.value = null;
                break;
            case "remove_file-upload-img-four":
                setImageFour(undefined)
                fourthRef.current.value = null;
                break;
        }
    }

    const pageSwitcher = () => {
        switch (step) {
            case 1:
                return stepOne();
            case 2:
                return stepTwo();
            case 3:
                return stepThree();
        }
    }

    return (
        
        <div className="container-sm optimized__d-flex-class flex-column h-100 mt-0 px-0 pb-4 justify-content-start about overflow-patch">
            <h1 className="register__page-title">{stepTitles[step] || ""}</h1>
            <PageIndicator current={step}/>
            <div className="optimized__d-flex-class flex-column px-4 mx-4 pb-4 about__description overflow-reset">
                <div className="optimized__d-flex-class flex-column py-3">
                    {
                        pageSwitcher()
                    }
                </div>
                <div className="optimized__d-flex-class flex-row-reverse">
                    <button disabled={isSending} className="register__button--danger flex-grow-1 px-1 py-3 mx-1" disabled={step === 1} onClick={onPrevPressed}>مرحله قبل</button>
                    {step === 3 ? (
                        <button disabled={isSending} className="register__button flex-grow-1 px-1 py-3 mx-1" onClick={onNextPressed}>ثبت آگهی</button>
                    ) : (
                        <button className="register__button flex-grow-1 px-1 py-3 mx-1" onClick={onNextPressed}>مرحله بعد</button>
                    )}
                    
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {

    const abandoned = ["مینی‌بوس", "کشاورزی", "کانکس", "جرثقیل"]
    return {
        gearbox: state.vehicleConfigs.general.gearbox,
        usages: state.vehicleConfigs.general.usage.filter(el => !abandoned.includes(el.name)),
        tire: state.vehicleConfigs.general.tireStatus,
        sellType: state.vehicleConfigs.general.sellType,
        reducedSellType: state.vehicleConfigs.general.sellType.reduce((acc, cur) => ({...acc, [cur.id]:cur.name}), {}),
        insurance: state.vehicleConfigs.general.insuranceStatus,
        state: state.vehicleConfigs.general.state,
        breakType: state.vehicleConfigs.general.breakType,
        bodyStatus: state.vehicleConfigs.general.bodyStatus,
        bodyColor: state.vehicleConfigs.general.bodyColor,
        interiorColor: state.vehicleConfigs.general.interiorColor,
        usageBrands: state.vehicleConfigs.usageBrands,
        validVehicles: state.vehicleConfigs.vehicles,
        cities: state.vehicleConfigs.cities,
        specialCategories: state.vehicleConfigs.specialCategories,
        userGalleries: state.galleryConfigs.userGalleries,
        userAgencies: state.agencyConfigs.userAgencies
    }
};

const mapDispatchToProps = (dispatch) => ({
    fetchBrands: (category) => dispatch(startgetVehicleBrands(category)),
    fetchVehicles: (brand, category) => dispatch(startgetValidVehicle(brand, category)),
    fetchSpecialCategory: (category) => dispatch(startgetSpecialCategories(category)),
    fetchCities: (state) => dispatch(startgetCitiesOfState(state)),
    createAd: (body) => dispatch(startCreateVehicleAd(body))
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleRegister);